__turbopack_context__.v({
  "button": "button-module-scss-module__Z2k9va__button",
  "disabled": "button-module-scss-module__Z2k9va__disabled",
  "responsive-image": "button-module-scss-module__Z2k9va__responsive-image",
});
